import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { OnboardingService } from "app/services/onboarding.service";

@Component({
  selector: "app-member-onboarding-form",
  templateUrl: "./member-onboarding-form.component.html",
  styleUrls: ["./member-onboarding-form.component.scss"],
})
export class MemberOnboardingFormComponent implements OnInit {
  memberForm!: FormGroup;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private onboardingService: OnboardingService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.memberForm = this.fb.group({
      fullName: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      phone: ["", [Validators.required, Validators.pattern(/^\+?\d{7,15}$/)]],
      age: ["", [Validators.min(1)]],
      registrationType: ["", Validators.required],
      interests: [[], Validators.required],
      source: ["", Validators.required],
      consentEmail: [false, Validators.requiredTrue],
    });
  }

  get f() {
    return this.memberForm.controls;
  }
  onNumberInput(event: KeyboardEvent): void {
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab"
    ) {
      event.preventDefault();
    }
  }
  onPhoneInput(event: KeyboardEvent, value: string): void {
    if (event.key === "+" && value.length === 0) {
      return;
    }
    if (
      !/[0-9]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab"
    ) {
      event.preventDefault();
    }
  }
  //

  onSubmit() {
    if (this.memberForm.invalid) {
      this.memberForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    const payload = this.memberForm.getRawValue();

    this.onboardingService.createMemberOnboardingRecord(payload).subscribe({
      next: (res) => {
        if (res && res.success) {
          const message =
            "Member onboarding submitted successfully. Check your email for details.";

          this.snackBar.open(message, "Close", {
            duration: 6000,
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: ["snackbar-success"],
          });

          this.router.navigate(["/home-landing"]);
        } else if (res.code === "EMAIL_EXISTS") {
          // ⚠️ Show custom message for existing email
          this.snackBar.open(
            "Email already exists in our system. Please try a different email.",
            "Close",
            {
              duration: 4000,
              horizontalPosition: "center",
              verticalPosition: "top",
              panelClass: ["snackbar-error"],
            }
          );
        } else {
          this.snackBar.open("Failed to submit onboarding form.", "Close", {
            duration: 3000,
            horizontalPosition: "center",
            verticalPosition: "top",
            panelClass: ["snackbar-error"],
          });
        }

        this.loading = false;
      },
      error: (err) => {
        console.error("❌ [FRONTEND] Onboarding submission failed:", err);

        if (err.status === 409 && err.error?.code === "EMAIL_EXISTS") {
          // ⚠️ Handle backend 409 error as well
          this.snackBar.open(
            "Email already exists in our system. Please try a different email.",
            "Close",
            {
              duration: 4000,
              horizontalPosition: "center",
              verticalPosition: "top",
              panelClass: ["snackbar-error"],
            }
          );
        } else {
          this.snackBar.open(
            "Something went wrong while submitting. Please try again.",
            "Close",
            {
              duration: 3000,
              horizontalPosition: "center",
              verticalPosition: "top",
              panelClass: ["snackbar-error"],
            }
          );
        }

        this.loading = false;
      },
    });
  }

  onSignatureInput(event: KeyboardEvent): void {
    if (
      !/[a-zA-Z\s]/.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Tab"
    ) {
      event.preventDefault();
    }
  }
}
